<template>
  <button
    ref="trigger"
    :aria-controls="id"
    :aria-expanded="active ? 'true': 'false'"
    :class="['btn routines-trigger', { 'routines-trigger--active' : active }]"
    @click="toggle"
  >
    <div class="routines-trigger__content">
      <slot />
    </div>
    <span class="arrow" />
  </button>
</template>

<script>
  import { throttle } from '@Foundation/utilities';
  import { eventBus } from '@Foundation/eventbus/eventbus';
  export default {
    name: 'RoutinesTrigger',
    props: {
      id: { type: String, required: true }
    },
    data() {
      return {
        active: false,
        smallScreen: !window.matchMedia('(min-width: 1025px)').matches
      };
    },
    mounted() {
      eventBus.$on('routines-update', (id) => {
        this.active = this.id === id;
      });

      /* istanbul ignore next */
      window.addEventListener('resize', throttle(() => {
        this.smallScreen = !window.matchMedia('(min-width: 1025px)').matches;
      }, 100));

      const active = document.querySelector('.routines-trigger--active');

      if (!active) {
        this.emitEvent();
      }
    },
    methods: {
      toggle() {
        const toggleIt = this.smallScreen ? (this.active ? null : this.id) : this.id;
        eventBus.$emit('routines-update', toggleIt);
        this.taggingEvent();
      },
      taggingEvent() {
        const li = this.$refs.trigger.parentElement;
        if (!this.smallScreen && (!li || !li.getAttribute('data-tag-action'))) {
          return;
        }

        const action = li.getAttribute('data-tag-action').split(/^(.*?)::/);
        if (action && action[1]) {
          li.setAttribute('data-tag-action', `${action[1]}::${this.active ? 'open' : 'minimize'}`);
          li.setAttribute('data-tag-click_action', this.active ? 'open' : 'minimize')
        }
      },
      emitEvent() {
        const firstEl = document.querySelectorAll('.routines-nav .routines-trigger')[0];
        if (!this.smallScreen && firstEl) {
          const firstID = firstEl.getAttribute('aria-controls');
          this.$nextTick(()=> {
            eventBus.$emit('routines-update', firstID);
          });
        }
      }
    }
  };
</script>
